// eslint-disable-next-line no-use-before-define
import ThemeProvider from '@mui/system/ThemeProvider';
import { SnackbarProvider } from 'notistack';
// eslint-disable-next-line no-use-before-define
import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import theme from './utils/theme';
import { AuthProvider } from './utils/context/Auth.context';
import { UserCompanyProvider } from './utils/context/UserCompany.context';

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={5}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <UserCompanyProvider>
                <App />
              </UserCompanyProvider>
            </AuthProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
